/**
 * JotAuditPageLayout Component
 *
 * Shared layout wrapper for all JotAudit pages providing consistent
 * max-width, padding, and container styling.
 */

import React from 'react';
import { Container } from '@mui/material';

interface JotAuditPageLayoutProps {
  /** Page content */
  children: React.ReactNode;
  /** Maximum width of the container */
  maxWidth?: 'xl' | 'lg' | 'md';
}

/**
 * JotAuditPageLayout
 *
 * Provides consistent layout styling across all JotAudit pages.
 * Defaults to 'xl' maxWidth with vertical padding of 3.
 */
export const JotAuditPageLayout: React.FC<JotAuditPageLayoutProps> = ({
  children,
  maxWidth = 'xl',
}) => {
  return (
    <Container maxWidth={maxWidth} sx={{ py: 3 }}>
      {children}
    </Container>
  );
};
